export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api-moneytoo.govotr.com/api';
export const API_ENDPOINTS = {
    CUSIPS: `${API_BASE_URL}/cusips`,
    SHAREHOLDERS: `${API_BASE_URL}/shareholders`,
    FTP: `${API_BASE_URL}/ftps`,
    LOGIN: `/auth/login`,
};

export const DEFAULT_PAGE_SIZE = 10; 